// What deleting a site can come to. A site with content cannot be deleted; a
// site with users is only deleted once the admin has confirmed removing them.
export const DELETE_SITE_STATUS = {
  BLOCKED: 'blocked',
  CONFIRM_USERS: 'confirm_users',
  DELETED: 'deleted',
  NOT_FOUND: 'not_found'
}
